module.exports = __webpack_public_path__ + "assets/img/shuibiao.5d80eb9c.gif";